import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5b374703"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = { class: "overflow-hidden" }
const _hoisted_3 = {
  class: "bg-white position-relative overflow-auto mw-100",
  style: {"max-height":"650px"}
}
const _hoisted_4 = { class: "table table-bordered" }
const _hoisted_5 = { class: "sticky-top bg-white" }
const _hoisted_6 = { class: "position-relative border-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-1" }, " Подразделение/Участок ", -1))
const _hoisted_8 = { class: "p-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-1" }, " Всего ", -1))
const _hoisted_10 = { class: "bg-primary bg-opacity-25" }
const _hoisted_11 = { class: "p-1" }
const _hoisted_12 = { class: "p-1 text-end" }
const _hoisted_13 = { class: "p-1 text-end" }
const _hoisted_14 = { class: "p-1" }
const _hoisted_15 = { class: "p-1 text-end" }
const _hoisted_16 = { class: "p-1 text-end" }
const _hoisted_17 = { class: "bg-success bg-opacity-25 sticky-bottom" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "p-1" }, " Итого ", -1))
const _hoisted_19 = { class: "p-1 text-end" }
const _hoisted_20 = { class: "p-1 text-end" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "10",
  class: "p-1 text-center"
}, "Записи отсутствуют", -1))
const _hoisted_23 = [
  _hoisted_22
]

import api from "@/api";
import { reactive } from "vue";
import moment from 'moment-timezone';

type organizationType = {
    id: number;
    name: string;
    count: number;
};

type subdivisionType = {
    name: string;
    count: {
        [name: string]: number;
    };
    totalCount: number;
    plots: subdivisionType[],
};

type reportStateType = {
    totalEmployeeCount: number;
    organizations: organizationType[];
    subdivisions: subdivisionType[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'HeadCountReportComponent',
  setup(__props) {


const state: reportStateType = reactive({
    organizations: [],
    subdivisions: [],
    totalEmployeeCount: 0,
});

const today = moment().tz('Asia/Almaty');

api.employees.getHeadCountReport().then((r) => {
    state.organizations = r.data.organizations;
    state.subdivisions = r.data.countBySubdivision;
    state.totalEmployeeCount = r.data.totalEmployeeCount;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, "Отчет по численности персонала по состоянию на " + _toDisplayString(_unref(today).format('DD.MM.YYYY')) + " г.", 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("thead", _hoisted_5, [
            _createElementVNode("tr", _hoisted_6, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.organizations, (organization) => {
                return (_openBlock(), _createElementBlock("th", _hoisted_8, _toDisplayString(organization.name), 1))
              }), 256)),
              _hoisted_9
            ])
          ]),
          _createElementVNode("tbody", null, [
            (state.subdivisions.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.subdivisions, (subdivision) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      _createElementVNode("tr", _hoisted_10, [
                        _createElementVNode("td", _hoisted_11, _toDisplayString(subdivision.name), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.organizations, (organization) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(subdivision.count[organization.name]), 1))
                        }), 256)),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(subdivision.totalCount), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subdivision.plots, (plot, plotIdx) => {
                        return (_openBlock(), _createElementBlock("tr", { key: plotIdx }, [
                          _createElementVNode("td", _hoisted_14, _toDisplayString(plot.name), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.organizations, (organization) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(plot.count[organization.name]), 1))
                          }), 256)),
                          _createElementVNode("td", _hoisted_16, _toDisplayString(plot.totalCount), 1)
                        ]))
                      }), 128))
                    ], 64))
                  }), 256)),
                  _createElementVNode("tr", _hoisted_17, [
                    _hoisted_18,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.organizations, (organization) => {
                      return (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(organization.count), 1))
                    }), 256)),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(state.totalEmployeeCount), 1)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("tr", _hoisted_21, _hoisted_23))
          ])
        ])
      ])
    ])
  ]))
}
}

})